import React, { FC } from 'react';

import css from './styles.module.scss';

interface EmptyStateProps {
  message?: string;
}

const EmptyState: FC<EmptyStateProps> = ({ message = 'Nothing to see here' }) => {
  return (
    <div className={css.container}>
      <div>{message}</div>
    </div>
  );
};

export default EmptyState;
